import React from 'react'; 

import mercedes from "../../../assets/bmw.jpg"

const Slider = () => {
    return (
       <div className='mt-5 mx-10'>
       <section className="dark:bg-indigo-500 dark:text-black rounded-lg">
	<div className="container max-w-6xl p-6 mx-auto space-y-6 sm:space-y-12">
		<a rel="noopener noreferrer" href="#" className="block max-w-sm gap-3 mx-auto sm:max-w-full group  lg:grid lg:grid-cols-12 dark:bg-white">
			<img src={mercedes} alt="" className="object-cover w-full h-64 sm:h-96 lg:col-span-7 dark:bg-gray-500" />
			<div className="p-6 space-y-2 lg:col-span-5">
				<h3 className="text-2xl font-semibold sm:text-4xl ">Buy Second Hand Fresh Car</h3>
				<span className="text-xs dark:text-gray-400">February 19, 2021</span>
				<p>Here you can find second hand fresh condition car in low price. Asap your seats now!</p>
			</div>
		</a> 
        </div>	 
</section>
       </div>
    );
};

export default Slider;